import type { StepView } from './onboarding-diagnosis';
import type { ReactElement } from 'react';

const DOT: Record<StepView['state'], string> = {
  done: 'bg-emerald-700 text-white',
  now: 'bg-accent text-white',
  err: 'bg-red-700 text-white',
  todo: 'border-[1.5px] border-border-strong',
  skip: 'border-[1.5px] border-dashed border-border-strong',
};
const MARK: Record<StepView['state'], string> = {
  done: '✓',
  now: '·',
  err: '✗',
  todo: '',
  skip: '',
};

/** A lista de passos da tentativa (prancha A5/A6). Puro render; o estado vem de `stepsFor`. */
export function OnboardingSteps({ steps }: { steps: StepView[] }): ReactElement {
  return (
    <ol
      className="mt-3 overflow-hidden rounded-md border border-border-default"
      aria-label="Passos da conexão"
    >
      {steps.map((s) => (
        <li
          key={s.key}
          className="grid grid-cols-[22px_minmax(0,1fr)] items-center gap-2.5 border-t border-border-subtle bg-surface px-3 py-2 text-xs first:border-t-0"
        >
          <span
            className={`grid h-4 w-4 place-items-center rounded-full text-[10px] font-bold ${DOT[s.state]}`}
            aria-hidden="true"
          >
            {MARK[s.state]}
          </span>
          <div>
            <div
              className={
                s.state === 'todo' || s.state === 'skip'
                  ? 'text-text-secondary'
                  : 'text-text-primary'
              }
            >
              {s.label}
            </div>
            {s.detail !== null && <div className="text-[11px] text-text-secondary">{s.detail}</div>}
          </div>
        </li>
      ))}
    </ol>
  );
}
